import { ICellRendererParams } from 'ag-grid-community';
import { IVoucherHolderForList } from '@nkr/models/index';
import { VoucherHolderType } from '@nkr/enums/index';
import { VoucherHolderAction } from '../voucher-holder-action';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';

const menuItemList = [
    { action: VoucherHolderAction.Edit, title: 'Edit' },
    { action: VoucherHolderAction.OrderBuccalSwabKit, title: 'Order Buccal Swab Kit' },
    { action: VoucherHolderAction.OrderLabScreening, title: 'Order Lab Screening' },
    { action: VoucherHolderAction.ReorderLabScreening, title: 'Reorder Lab Screening' },
    { action: VoucherHolderAction.ResendLink, title: 'Re-send Invite' },
    { action: VoucherHolderAction.StartRedemption, title: 'Start Redemption' },
    { action: VoucherHolderAction.UploadVoucherConsent, title: 'Upload Voucher Consent' },
    { action: VoucherHolderAction.UploadSwabResults, title: 'Upload Swab Results' },
    { action: VoucherHolderAction.UploadScreeningResults, title: 'Upload Screening Results' },
    { action: -1, title: '' }
];

interface IProps {
    data: IVoucherHolderForList,
    isAdmin: boolean,
    isAdminLogin: boolean,
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: VoucherHolderAction) => void
}

const ActionButtonRenderer = (props: ICellRendererParams & IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: any, action: number) => {
        props.onItemSelected(id, action);
    };

    const getUrl = (action: VoucherHolderAction, id: number) => {
        let voucherHolder = props.data as IVoucherHolderForList;
        let hrefPrefix = props.isAdmin ? `/admin/donor/${voucherHolder.donorId}/voucher` : `/center/${voucherHolder.donorCenterId}/donor/${voucherHolder.donorId}/voucher`;       

        switch (action) {
            case VoucherHolderAction.Edit: return `${hrefPrefix}/${voucherHolder.id}`;
            case VoucherHolderAction.StartRedemption: return `/center/${voucherHolder.donorCenterId}/donor/${voucherHolder.donorId}/profile/vouchers`;
            case VoucherHolderAction.OrderBuccalSwabKit:
            case VoucherHolderAction.OrderLabScreening:
            case VoucherHolderAction.UploadVoucherConsent:
            case VoucherHolderAction.UploadSwabResults:
            case VoucherHolderAction.UploadScreeningResults: return null;
        }

        return null;
    }

    const getMenuItems = () => {
        let data = props.data as IVoucherHolderForList;

        let menuItems = [];

        menuItems.push(VoucherHolderAction.Edit);

        if (props.isAdmin || props.isAdminLogin) {
            if (props.data.typeId != VoucherHolderType.StandardVoucher) {
                menuItems.push(-1);
                menuItems.push(VoucherHolderAction.OrderBuccalSwabKit);

                if (data.lastScreeningOrderedDateTime != '') {
                    menuItems.push(VoucherHolderAction.ReorderLabScreening);
                }
            }
        }

        if (!props.data.donorDonated) {
            menuItems.push(-1);
            menuItems.push(VoucherHolderAction.ResendLink);
        }

        menuItems.push(-1);
        menuItems.push(VoucherHolderAction.StartRedemption);

        menuItems.push(-1);
        menuItems.push(VoucherHolderAction.UploadVoucherConsent);

        if (props.data.typeId != VoucherHolderType.StandardVoucher) {
            menuItems.push(VoucherHolderAction.UploadSwabResults);
            menuItems.push(VoucherHolderAction.UploadScreeningResults);
        }

        return menuItems;
    };

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action, props.data.id) : null;
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={url}>{item.title}</a>, url, title: item.title };
        }
    });

    return (
        <OverlayMenuButton
            menu={menu}
            bsStyle='primary'
            bsSize='xs'
            title='Actions'
            listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
            includeCaret={true}
            onToggle={handleMenuToggle}
            onSelect={handleMenuSelection}
        />
    );
}

export default ActionButtonRenderer;